import { Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { getInitials } from '../../utils/helpers';

export function Header() {
  const { user } = useAuth();

  const displayName = user?.displayName || user?.email?.split('@')[0] || 'Admin';
  const email = user?.email || 'admin@obaet.com';
  const initials = getInitials(displayName);

  return (
    <header className="h-16 bg-[#0f0f1a]/80 backdrop-blur-md border-b border-[#252535] flex items-center justify-between px-8 sticky top-0 z-10">
      <div>
        <h1 className="text-[15px] font-semibold text-[#f1f5f9]">Admin Dashboard</h1>
        <p className="text-xs text-[#64748b]">Manage your OBAET platform</p>
      </div>

      <div className="flex items-center gap-3">
        {/* Notification bell */}
        <button className="relative p-2 rounded-xl text-[#64748b] hover:text-[#f1f5f9] hover:bg-[#1c1c2a] transition-all duration-200">
          <Bell className="w-4.5 h-4.5" />
          <span className="absolute top-2 right-2 w-1.5 h-1.5 bg-[#ef4444] rounded-full ring-2 ring-[#0f0f1a]" />
        </button>

        {/* Divider */}
        <div className="w-px h-6 bg-[#252535]" />

        {/* User */}
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 gradient-blue rounded-xl flex items-center justify-center text-white text-xs font-semibold shadow-sm">
            {initials}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-medium text-[#f1f5f9] leading-tight">{displayName}</p>
            <p className="text-xs text-[#64748b] leading-tight">{email}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
